import {VUE_DATA_TABLE_TYPE} from '../../vue-data-table-form-types';
import VueDataTableFormText from "./VueDataTableFormText";

export default {
    [VUE_DATA_TABLE_TYPE.TEXT]: VueDataTableFormText,
}